import { takeEvery } from "redux-saga/effects";
import {
  getBalanceAction,
  addBalanceAction,
  getAllEarningAction,
  getAllStatementsAction,
} from "./slices";
import {
  getBalanceWorker,
  addBalanceWorker,
  getAllEarningWorker,
  getAllStatementsWorker,
} from "./workers";

const balanceWatcher = [
  takeEvery(getBalanceAction, getBalanceWorker),
  takeEvery(addBalanceAction, addBalanceWorker),
  takeEvery(getAllEarningAction, getAllEarningWorker),
  takeEvery(getAllStatementsAction, getAllStatementsWorker),
];

export default balanceWatcher;
